import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

import { ModelOfBidding } from '../../database/index';

import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { useData } from 'src/contexts/data';
import { dateToString } from 'src/utils/dateToString';

export const useFormCreateBidding = () => {
    const { userAgencyId } = useAuth();
    const { currentBidding, handleBidding } = useData();
    const [loading, setLoading] = useState<boolean>(false);

    const toast: any = useRef();

    const validationSchema = Yup.object().shape({
        OBJETO: Yup.string().required('* Campo obrigatório'),
        MODALIDADE: Yup.string().required('* Campo obrigatório'),
        NUMEROLICITACAO: Yup.string().required('* Campo obrigatório'),
        NUMEROPROCESSOADM: Yup.string().required('* Campo obrigatório'),
        DATALICITACAO: Yup.string().required('* Campo obrigatório'),
        VALORGLOBAL: Yup.number().typeError('O valor informado deve ser um número.').required('* Campo obrigatório'),
        STATUS: Yup.number().required('* Campo obrigatório'),
    });

    const saveBidding = (Bidding: ModelOfBidding) => {
        setLoading(true);

        const newBidding: ModelOfBidding = {
            ...Bidding,
            DATALICITACAO: moment(Bidding.DATALICITACAO, 'DD/MM/YYYY')
                .toDate()
                .toLocaleDateString('en', { year: 'numeric', month: '2-digit', day: '2-digit' }),
            ORGAO: userAgencyId,
        };

        if (currentBidding?.ID) {
            api.put(`biddings/${currentBidding.ID}`, newBidding)
                .then(response => {
                    handleBidding({
                        ...response.data[0],
                        DATALICITACAO: dateToString(response.data[0].DATALICITACAO, 'br'),
                    });
                    setLoading(false);
                    toast.current.show({
                        severity: 'success',
                        summary: 'Edição realizada',
                        detail: 'A licitação foi editada com sucesso!',
                        life: 5000,
                    });
                })
                .catch(err => {
                    console.log(err);
                    setLoading(false);
                    toast.current.show({
                        severity: 'error',
                        summary: 'Edição não realizada',
                        detail: 'Falha ao realizar operação!',
                        life: 5000,
                    });
                });
        } else {
            api.post('biddings', newBidding)
                .then(response => {
                    handleBidding({
                        ...response.data[0],
                        DATALICITACAO: dateToString(response.data[0].DATALICITACAO, 'br'),
                    });
                    setLoading(false);
                    toast.current.show({
                        severity: 'success',
                        summary: 'Cadastro realizada',
                        detail: 'A licitação foi cadastrada com sucesso!',
                        life: 5000,
                    });
                })
                .catch(err => {
                    setLoading(false);
                    toast.current.show({
                        severity: 'error',
                        summary: 'Cadastro não realizado',
                        detail: 'Falha ao realizar operação!',
                        life: 5000,
                    });
                });
        }
    };

    const formik = useFormik<ModelOfBidding>({
        initialValues: {
            ORGAO: '',
            OBJETO: '',
            MODALIDADE: '',
            DATALICITACAO: '',
            VALORGLOBAL: 0,
            NUMEROLICITACAO: '',
            NUMEROPROCESSOADM: '',
            STATUS: 0,
        },
        onSubmit: values => saveBidding(values),
        validationSchema,
    });

    return {
        getController: {
            formik,
            loading,
            toast,
        },
    };
};
